import styled from 'styled-components';

import { themeColor } from '~/common/utils/theme';
import { Label, Value } from '~/components/SimpleInfo/styled';

export const Wrapper = styled.div<{ compact?: boolean }>`
  ${Label} {
    font-size: ${({ compact }) => (compact ? '14px' : '16px')};
    font-weight: 600;
    line-height: ${({ compact }) => (compact ? '16px' : '18px')};
    color: ${themeColor('element.primary')};
  }

  ${Value} > span {
    font-weight: 400;
    line-height: 20px;
    color: ${themeColor('element.secondary')};
  }
`;

export const Column = styled.div`
  flex: 1;
  flex-direction: column;
  margin: 0 10px;

  > div {
    margin-bottom: 10px;
    min-height: 65px;
    gap: 4px;
  }

  > div:last-child {
    margin-bottom: 0;
  }
`;

export const Block = styled.div`
  display: flex;
  flex-direction: row;

  ${Column}:first-child {
    margin: 0 10px 0 0 !important;
  }
`;
